import { Skeleton } from '@uconnect/assets/components/ui/skeleton';

export function RestoringSearchSkeletonLoader() {
	// Generate random widths for skeleton variation (70-85% of available space)
	const randomWidths = Array.from({ length: 6 }).map(() => Math.floor(Math.random() * 16) + 70);

	return (
		<div className="flex flex-col gap-4">
			<div className="sr-only">Restoring search…</div>
			<Skeleton className="h-16 w-3/5 bg-accent! ml-auto!" />
			<div className="flex flex-col gap-3">
				{Array.from({ length: 4 }).map((_, i) => (
					<Skeleton
						key={i}
						className="h-6 bg-accent!"
						style={{ width: `${randomWidths[i]}%` }}
					/>
				))}
			</div>
		</div>
	);
}
